<template>
	<div>
		<div class="col-md-12">
			<div class="d-flex justify-content-between ts-mb-4">
				<label class="btn btn-sm btn-flat-info btn-outline-info" for="photofile">{{
					$t('productProfile.uploadPhoto')
				}}</label>
				<input type="file" id="photofile" ref="photofile" style="display:none" multiple
					@change="onUploadFileChange" />
			</div>
			<table style="width:100%">
				<tr v-for="(photo, index) in model.attach_file_list" :key="index">
					<td style="width:20%" v-viewer>
						<img :src=readFromUrl(photo) alt="" class="ts-w-32 ts-h-32 ts-mb-4">
					</td>
					<td style="width:25%" class="mt-2" :class="{ 'text-red': photo.invalid_file }">
						{{ photo.original_file_name }}
					</td>
					<!-- <td class="text-center" style="width:5%">
						<a-popconfirm placement="leftTop" :title="$t('are_you_sure_to_delete')" :ok-text="$t('yes')"
							:cancel-text="$t('no')" @confirm="onRemoveFile(index, photo)">
							<a href="#" class="text-red" v-if="photo.progressing == 100">
								<i class="fa fa-times"></i>
							</a>
						</a-popconfirm>
					</td> -->
				</tr>
			</table>
		</div>
	</div>
</template>
<script>
import { mapActions } from 'vuex'
import httpClient from '@/http-client'
import VueViewer from 'v-viewer'
import Vue from 'vue'
import 'viewerjs/dist/viewer.css'
Vue.use(VueViewer)

export default {
	name: 'uploadPhoto',
	props: ['value', 'photos'],
	data() {
		return {
			src: null
		}
	},
	created() {
		this.model = this.value;
		this.photos = this.photos;
		this.setEdit()
	},
	methods: {
		...mapActions('product/profile', ['removeFileUploaded']),
		onUploadFileChange(e) {
			let files = e.target.files
			this.model.attach_file_list = [
				...this.model.attach_file_list,
				..._.map(files, file => ({
					picture_id: 0,
					file_path: null,
					original_file_name: file.name,
					remarks: null,
					size: parseInt(file.size / 1024),
					size_text: parseInt(file.size / 1024) + 'KB',
					type: file.type,
					progressing: 0,
					invalid_file: this.validate(file),
					file: file,
					uploaded: false,
					storage_path: null
				}))
			]
			_.forEach(
				this.model.attach_file_list.filter(file => file.uploaded == false),
				(f, index) => {
					if (!this.validate(f.file)) {
						let frm = new FormData()
						frm.append('file', f.file)
						frm.append('file_type', 1)
						httpClient
							.post('/api/v1/product-profiles/upload-files', frm, {
								onUploadProgress: el => {
									if (el.lengthComputable) {
										f.progressing = Math.round((el.loaded * 100) / el.total)
									}
								}
							})
							.then(response => {
								f.uploaded = true
								f.storage_path = response.data.file_path
								f.file_path = response.data.file_path
							})
							.catch(error => {
								this.$toasted.error(error.message)
							})
					}
				}
			)
		},
		readFromUrl(item) {
			if (item.file instanceof File) {
				return URL.createObjectURL(item.file);
			}
			return item.storage_path
		},
		validate(file) {
			let ALLOW_FILE = [
				'image/png',
				'image/jpeg',
				'application/pdf',
				'application/vnd.openxmlformats-officedocument.presentationml.presentation',
				'application/vnd.ms-powerpoint',
				'application/vnd.ms-excel',
				'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
				'application/msword'
			]

			if (file.size > 10000000 * 10 || !ALLOW_FILE.includes(file.type)) {
				return true
			}

			return false
		},
		onRemoveFile(index, record) {
			if (record.picture_id > 0) {
				this.removeFileUploaded({
					picture_id: record.picture_id,
					file_path: record.file_path
				})
			}
			let file_index = this.model.attach_file_list.indexOf(
				...this.model.attach_file_list.filter(
					f => f.file_path == record.file_path && f.picture_id == record.picture_id
				)
			)
			this.model.attach_file_list.splice(file_index, 1)
		},
		setEdit() {
			if (this.photos.serial_photo) {
				this.model.attach_file_list = this.photos.serial_photo
					.map(el => ({
						original_file_name: el.original_file_name,
						size: 0,
						size_text: 0,
						type: el.mime_type,
						progressing: 100,
						invalid_file: false,
						file: el.file_path,
						file_path: el.file_path,
						uploaded: true,
						picture_id: el.picture_id,
						storage_path: el.storage_path,
						remarks: el.remarks
					}))
			}
		}
	}
}
</script>